<template>
  <header v-if="
  ($route.path !== '/edit-password-comp' && $route.path !== '/password-reset-comp') &&
  !$route.path.includes('/sign')">
    <div class="btn_pgback" @click="goBack">
      <img src="@/assets/images/btn_back.png" v-if="$route.path !== '/'" alt="뒤로가기버튼">
    </div>
    <h1 @click="$router.push('/')">파르나스</h1>
    <h3 v-if="$route.path !== '/phone-auth'">{{$route.meta.title}}</h3>
    <button class="btn" @click="setIsMenuOpen"></button>
  </header>
  <button id="page_cover" class="page_cover" :class="{'open': open || isOnBlackPageCover}"></button>
</template>

<script>
import {mapGetters, mapMutations} from "vuex"
export default {
  name: "HeaderView",
  computed: {
    ...mapGetters({
      open: "getIsMenuOpen",
      isOnBlackPageCover: 'getIsOnBlackPageCover'
    })
  },
  methods: {
    ...mapMutations(["setIsMenuOpen"]),
    /**
     * 뒤로가기
     *
     * 1) meta.backTo 가 있으면 히스토리 대신 그 경로로 이동한다.
     *    결제 완료 화면처럼 뒤로가면 만료된 외부 페이지(PG 결제창)로 돌아가는 경우에 쓴다.
     * 2) 앱 안에 돌아갈 이력이 없으면 홈으로 보낸다.
     * 3) 그 외에는 평소대로 히스토리를 하나 되돌린다.
     *
     * 2번이 필요한 이유 — 문자 딥링크나 새로고침으로 특정 화면에 "첫 진입" 하면
     * SPA 히스토리가 그 화면 하나뿐이라(진입 시 리다이렉트·로그인 복귀 모두 replace 다)
     * go(-1) 이 앱 밖으로 나가 버린다. 이때 사파리가 bfcache 에 남아 있던
     * 로그인 전 메인 화면 스냅샷을 복원해, 로그인했는데도 비로그인 화면이 뜬 것처럼 보인다.
     * (2026-08-12 실기기 확인)
     */
    goBack() {
      const {backTo} = this.$route.meta
      if (backTo) {
        this.$router.replace(backTo)
        return
      }
      // vue-router 가 history.state 에 넣는 값이다. 앱 내 이전 화면이 없으면 null 이다.
      const hasHistory = !!(window.history.state && window.history.state.back)
      if (hasHistory) {
        this.$router.go(-1)
      } else {
        this.$router.replace('/')
      }
    }
  }
}
</script>

<style scoped>
</style>
